import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

export const useDeleteTeam = () => {
  const queryClient = useQueryClient();

  const deleteTeam = async (teamId: number) => {
    const response = await Axios.delete(
      DELETE_URL(teamId.toString()).deleteTeam
    );
    return response.data;
  };

  return useMutation<void, AxiosError<BaseError>, number>(
    ['deleteTeam'], // Mutation key for better Sentry logging
    (teamId: number) => deleteTeam(teamId),
    {
      onSuccess: (_, teamId) => {
        queryClient.invalidateQueries(['teams']);
        queryClient.invalidateQueries(['teams', teamId]);
      },
      useErrorBoundary: false
    }
  );
};
